import React, { useEffect, useState } from "react";
import { IonIcon, IonSearchbar, IonButton, IonModal, IonItem, IonLabel, IonGrid, IonRow, IonCol, IonList, IonCheckbox, IonRadioGroup, IonRadio } from "@ionic/react";
import { chevronBackOutline, arrowDownCircleSharp } from "ionicons/icons";
import "./SelectUserComponent.scss";
import { utilService } from "../../../../services/utilService";
import { rolePermissionsService } from "../../../../services/rolePermissions.service";
import { FileShareListComponentService } from "./SelectUserComponent.service";
import {
  FileShareFullListInterface,
  MediaItemForwardModel,
} from "./SelectUserComponent.model";
import DoctorList from "../../../../components/Shared/DoctorList/doctor-list";
import { CONSTANTS } from "../../../../constants/callcentral.constants";
import Loader from "../../../../components/Shared/Loader/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import _ from "lodash";
import { useToast } from "@agney/ir-toast";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { DoctorDataModel } from "../../../../components/Shared/DoctorList/Components/DoctorCard/doctor-card.model";
import { isFullscreen } from "screenfull";
import { MediaUploadService } from "../MediaUpload/MediaUpload.service";
import { homePageService } from "../../../Home/Home.service";
import { NetworkListResponseModal } from "../../../OnCallLookUp/OnCallLookUpModel";
import { OnCallLookUpInputService } from "../../../OnCallLookUp/OnCalllookUpService";
import DownArrowIcon from "../../../../assets/icons/commonIcons/down-arrow.png"
import { loggedInUserService } from "../../../../services/loggedInUser.service";
import { useTranslation } from "react-i18next";

interface SelectUserComponentProps {
  isModalPopUpScreen?: boolean;
  dataFromParentComponent?: any;
  isMessageComponent?: boolean;
  isRoutedFromMessages?: any;
  isForwardMessage?: any;
  forwardMessageDetails?: any;
  fromDet?: any;
  onCancel: () => void;
  getSelectedCard: (data: Array<DoctorDataModel>) => void;
  n2nNetwork?: string;
}
const SelectUserComponent: React.FC<SelectUserComponentProps> = (props) => {
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [selectedDoctorList, setSelectedDoctorList]: any = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [apiParams, setApiParams]: any = useState({});
  const [selectSortId, setSelectSortId]: any = useState(0);
  const [userListData, setUserListDate]: any = useState([]);
  const [forwardMediaItem, setForwardMediaItem]: any = useState([]);
  const [isRoutedFromMediaList, setIsRoutedFromMediaList]: any =
    useState(false);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [isNetworkModalOpen, setIsNetworkModalOpen] = useState<boolean>(false);
  const [selectedNetwork, setSelectedNetwork] = useState<any>(null)
  const [choosenNetwork, setChoosenNetwork] = useState<any>(null)
  const [networkList, setNetworkList] = useState<any>([])
  const { t } = useTranslation("messages");
  const Toast = useToast();
  let history = useHistory();
  const location: any = useLocation();

  const [currentUser, setCurrentUser] = useState<any>(null);
  const [isN2nPermission, setisN2nPermission] = useState<any>(false);

  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setisN2nPermission(data?.userData?.n2nActivation)
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (networkList?.length > 0 && !location?.state?.n2nNetwork && !props?.n2nNetwork) {
      const defNetwork = networkList?.find((network: any) => network?.default)
      setSelectedNetwork(defNetwork?.network)
      setChoosenNetwork(defNetwork?.network)
    }
  }, [networkList])


  const getHomePageData = async () => {
    const params: any = {
      // "schedule-name-list": scheduleList,
      hour: utilService.getCurrentHour().toString(),
      minute: utilService.getCurrentMinutes().toString(),
      date: utilService.getCurrentDate().toString(),
    };

    const respResult: any = await homePageService.getHomePageData(params);
    if (respResult.isSuccess) {
      setCurrentUser(respResult!.result!.currentUser);
    }
  };

  useEffect(() => {
    getHomePageData();
  }, [location]);

  useEffect(() => {
    setChoosenNetwork(location?.state?.n2nNetwork)
    setSelectedNetwork(location?.state?.n2nNetwork)
  }, [location]);

  useEffect(() => {
    if (props?.n2nNetwork) {
      setChoosenNetwork(props?.n2nNetwork)
      setSelectedNetwork(props?.n2nNetwork)
    }
  }, [props?.n2nNetwork]);

  const addMember = async (selectedUsers: any) => {
    const guids = [
      ...selectedUsers,
      ...location?.state?.selectedUserMsg?.thread_users,
    ]?.map((user: any) => user?.guid);
    const userIDs = [
      ...selectedUsers,
      ...location?.state?.selectedUserMsg?.thread_users,
    ]?.map((user: any) => user?.id);
    const names = selectedUsers?.map((member: any) => member?.firstName);
    let clientMediaID = Math.floor(Math.random() * 10000);
    const params = {
      clientMediaID: clientMediaID,
      from_guid: [utilService.getLoggedUserGuid()],
      to_guid: JSON.stringify(
        guids?.filter((guid: any) => guid !== utilService.getLoggedUserGuid())
      ),
      message: `${currentUser?.firstName} added ${names?.join(", ")}`,
      type: "4",
      action: "6",
      name: "",
      sms_thread_id: location?.state?.selectedUserMsg?.sms_thread_id,
      file: "",
      size: "",
      id: "",
      is_quoted_reply: false,
      quoted_message_id: "",
      is_group_sms: true,
      send_to_all: true,
      reg_code: utilService.getNetwork(),
      is_n2n_message: selectedNetwork && utilService.getNetwork() !== selectedNetwork ? true : false,
      to_user_data: selectedNetwork && utilService.getNetwork() !== selectedNetwork ? JSON.stringify([{ "network": selectedNetwork, "user_guids": guids?.filter((guid: any) => guid !== utilService.getLoggedUserGuid()), "user_ids": userIDs ?? [] }]) : ""
    };
    const formData = utilService.constructFormData(params);
    const respFileShareMediaListResult: any =
      await MediaUploadService.mediaUpload(formData);
    if (respFileShareMediaListResult?.isSuccess) {
      Toast.success("Member added successfully");
      history.goBack();
    }
  };

  useEffect(() => {
    getNetworkList()
    if (props.dataFromParentComponent) {
      setForwardMediaItem(props.dataFromParentComponent.mediaItem);
      setIsRoutedFromMediaList(
        props.dataFromParentComponent.isCalledFromMediaListComponent
      );
    }
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    getFileShareListDetails(searchText, 1);
    checkIfLargeScreen();
  }, []);

  useEffect(() => {
    if (
      !_.isEmpty(location.state) &&
      location.pathname === "/client/file-share/selectuser"
    ) {
      const currentLocation: any = location;
      setForwardMediaItem(currentLocation.state.mediaItem);
      setIsRoutedFromMediaList(
        currentLocation.state.isCalledFromMediaListComponent
      );
    }
  }, [location]);

  useEffect(() => {
    getFileShareListDetails(searchText, 1);
  }, [selectSortId]);

  useEffect(() => {
    if (props.isForwardMessage) {
      setIsRoutedFromMediaList(true);
    }
  }, [props.isForwardMessage]);

  let doctorListMessage = {
    componentName: CONSTANTS.COMPONENTS.FILE_SHARE,
    isMultiSelectEnabled: true,
    isShowColorBadge: false,
  };

  const forwardMessage = async () => {
    const params: any = getForwardMessageItemParams();
    const ForwardMessage: MediaItemForwardModel =
      await FileShareListComponentService.forwardMedia(params);
    if (ForwardMessage.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.MESSAGE_FORWARD_SUCCESS);
      setSelectedDoctorList([]);
      props.onCancel()
    } else {
      console.log("error");
      FileShareListComponentService.handleErrorResponse();
    }
    setShowLoader(false);
  };

  const getNetworkList = async () => {
    const logedUserNetwork = utilService.getNetwork()
    const apiResponse: NetworkListResponseModal = await OnCallLookUpInputService.getOnCallLookUpNetworksList({
      reg_code: utilService.getNetwork(),
    });

    if (apiResponse.isSuccess) {
      const networkList_res: any = apiResponse?.networkData
      setNetworkList(networkList_res?.data);
      // setChoosenNetwork(logedUserNetwork)
      // setSelectedNetwork(logedUserNetwork)
      // onCallSearchResultService.setonCallSiteListFromComponent(networkList_res);
    }
  };

  const getForwardMessageItemParams = () => {
    return {
      message_media_id: props.forwardMessageDetails.id,
      reg_code: utilService.getNetwork(),
      time: utilService.getCurrentDateAndTime(),
      users: getSelectedDoctorListIds(),
      is_forwarded: true,
      is_media: false,
      user_guid: utilService.getLoggedUserGuid(),
      is_group_sms: false,
      is_broadcast_sms: false,
      sms_thread_id: "",
      is_n2n_message: selectedNetwork && selectedNetwork !== utilService.getNetwork() ? true : false,
      to_user_data: selectedNetwork && selectedNetwork !== utilService.getNetwork() ? [{ "network": selectedNetwork, "user_guids": getSelectedDoctorListIds(), "user_ids": [] }] : ""
    };
  };

  const getFileShareListDetails = async (
    searchedName: string,
    pageNumber: number,
    n2nNetwork?: string
  ) => {
    setShowLoader(pageNumber === 1);
    const fromN2NNetwork = location?.state?.n2nNetwork ? location?.state?.n2nNetwork : props?.n2nNetwork
    const params: any = getFileShareDoctorListParams(searchedName, pageNumber, n2nNetwork ? n2nNetwork : fromN2NNetwork);
    if (!props.isMessageComponent) {
      const respFileShareListResult: any =
        await FileShareListComponentService.getFileShareFullListDetails(
          params,
          searchedName
        );
      if (respFileShareListResult.isSuccess && respFileShareListResult.result) {
        if (!_.isEmpty(respFileShareListResult.result)) {
          if (pageNumber === 1) {
            setUserListDate(respFileShareListResult.result?.[0]?.data);
            // setShowLoader(false);
          } else {
            setUserListDate([
              ...userListData,
              ...respFileShareListResult.result?.[0]?.data,
            ]);
            // setShowLoader(false);
          }
          const hasMore =
            respFileShareListResult.result?.[0]?.data.length <
            respFileShareListResult?.result?.[0]?.count;
          setHasMoreItems(hasMore);

          setPageNo(pageNumber);
        } else {
          setHasMoreItems(false);
        }
      }
      // setShowLoader(false);
    }

    if (props.isMessageComponent) {
      const respFileShareListResult: any =
        // await FileShareListComponentService.getFileShareRecentFullListDetails(
        //   params,
        //   searchedName
        // );
        await FileShareListComponentService.getFileShareFullListDetails(
          params,
          searchedName
        );

      if (respFileShareListResult.isSuccess && respFileShareListResult.result) {
        if (!_.isEmpty(respFileShareListResult.result)) {
          if (pageNumber === 1) {
            let resultDoctorListData = [
              ...respFileShareListResult.result?.[0]?.data,
            ];

            let filteredDoctorListArray = resultDoctorListData.filter(
              (doctorListOne: any) => {
                return selectedDoctorList.some(
                  (doctorListTwo: any) =>
                    doctorListOne.guid === doctorListTwo.guid
                );
              }
            );

            filteredDoctorListArray.map((doctorCardItem) => {
              if (doctorCardItem?.guid) {
                return (doctorCardItem.isSelected = true);
              }
            });

            setUserListDate(respFileShareListResult.result?.[0]?.data);
          } else if (selectedDoctorList) {
            let combinedSelectUser = [
              ...userListData,
              ...respFileShareListResult.result?.[0]?.data,
            ];

            let filteredDoctorListArray = combinedSelectUser.filter(
              (doctorlistone: any) => {
                return selectedDoctorList.some(
                  (doctorlisttwo: any) =>
                    doctorlistone.guid === doctorlisttwo.guid
                );
              }
            );

            filteredDoctorListArray.map((doctorcarditem) => {
              if (doctorcarditem?.guid) {
                return (doctorcarditem.isSelected = true);
              }
            });

            setUserListDate(combinedSelectUser);
          } else {
            setUserListDate([
              ...userListData,
              ...respFileShareListResult.result?.[0]?.data,
            ]);
          }
          const hasMore =
            respFileShareListResult.result?.[0]?.data.length <
            respFileShareListResult?.result?.[0]?.count;
          setHasMoreItems(hasMore);
          setPageNo(pageNumber);
        } else {
          setHasMoreItems(false);
        }
      }
    }
    setShowLoader(false);
  };

  const handleSearch = (event: any) => {
    if (pageNo === 1) {
      setHasMoreItems(false);
    }
    getFileShareDoctorListParams(event.detail.value, 1);
    getFileShareListDetails(event.detail.value, 1, selectedNetwork);
    let filteredDoctorListArray = userListData.filter((doctorListOne: any) => {
      return selectedDoctorList.some(
        (doctorListTwo: any) => doctorListOne.guid === doctorListTwo.guid
      );
    });

    filteredDoctorListArray.map((doctorCardItem: any) => {
      if (doctorCardItem?.guid) {
        return (doctorCardItem.isSelected = true);
      }
    });
  };

  const getFileShareDoctorListParams = (
    searchedName: string,
    pageNumber: number,
    n2n_network?: string
  ) => {
    return {
      search_name: searchedName,
      page: pageNumber,
      reg_code: utilService.getNetwork(),
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      n2n_network: n2n_network ?? ""
    };
  };

  const getSelectedDoctorList = (doctorList: any) => {
    setSelectedDoctorList(_.cloneDeep(doctorList));
  };

  const getSelectedDoctorListIds = () => {
    const selectedDoctorListIds: any = [];
    if (!_.isEmpty(selectedDoctorList)) {
      selectedDoctorList.map((doctorListItem: any) => {
        selectedDoctorListIds.push(doctorListItem.guid);
      });
    }
    return selectedDoctorListIds;
  };

  const forwardMediaListItem = async () => {
    // setShowLoader(true);
    const params: any = getForwardMediaItemParams();
    const respFileShareMediaListResult: MediaItemForwardModel =
      await FileShareListComponentService.forwardMediaListItem(params);
    if (respFileShareMediaListResult.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.MEDIA_FORWARD_SUCCESS);
      setSelectedDoctorList([]);
      props.onCancel()
    } else {
      console.log("error");
      FileShareListComponentService.handleErrorResponse();
    }
    setShowLoader(false);
  };

  const getMediaType = (type: any) => {
    switch (type) {
      case "Image":
        return 1;
      case "Audio":
        return 2;
      case "Video":
        return 2;
      default:
        return "";
    }
  };

  const getForwardMediaItemParams = () => {
    const mediaType = getMediaType(
      props?.forwardMessageDetails?.media_data?.[0]?.media_type
    );
    return {
      action: CONSTANTS.MEDIA_ACTIONS.FORWARD,
      from_guid: utilService.getLoggedUserGuid(),
      id: props?.forwardMessageDetails?.id,
      type: mediaType,
      to_guid: getSelectedDoctorListIds(),
      reg_code: utilService.getNetwork(),
      is_forwarded: true,
      is_media: true,
      is_group_sms: false,
      is_broadcast_sms: false,
      sms_thread_id: "",
      is_n2n_message: selectedNetwork && selectedNetwork !== utilService.getNetwork() ? true : false,
      to_user_data: selectedNetwork && selectedNetwork !== utilService.getNetwork() ? [{ "network": selectedNetwork, "user_guids": getSelectedDoctorListIds(), "user_ids": [] }] : ""
    };
  };

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const onRedirectToMessageNext = () => {
    props.getSelectedCard(_.cloneDeep(selectedDoctorList));
    props.onCancel();
  };

  const handelNetworkModalCancel = () => {
    setIsNetworkModalOpen(false)
    setSelectedNetwork(selectedNetwork)
    setChoosenNetwork(selectedNetwork)
  }

  const handelNetworkModalSubmit = () => {
    setIsNetworkModalOpen(false)
    setSelectedNetwork(choosenNetwork)
    getFileShareListDetails(searchText, 1, choosenNetwork);
    setSelectedDoctorList([])
  }

  const onNetworkChange = (value: any) => {
    setChoosenNetwork(value)
  }

  return (
    <div className="file-share-list-container">
      {!props.isForwardMessage && (
        <div
          className={`file-share-select-user-header ${props.isModalPopUpScreen
              ? "file-share-select-user-header-height"
              : ""
            }`}
        >
          <div
            className="back-icon"
            onClick={() => {
              props.isModalPopUpScreen || props.isRoutedFromMessages
                ? props.onCancel()
                : history.goBack();
            }}
          >
            <IonIcon icon={chevronBackOutline} />
          </div>
          <div className="header-label">{t("select")}</div>
        </div>
      )}
      <div
        className={`dropdown-main-container network-container ${(isSmallScreen || props.isModalPopUpScreen) &&
          "dropdown-main-container-small-screen"
          }`}
      >
        <div className="searchbar-containar-item">
          <IonSearchbar
            debounce={1000}
            value={searchText}
            onIonChange={(e) => {
              setPageNo(1);
              setSearchText(e.detail.value!);
              handleSearch(e);
            }}
            onIonClear={(e) => {
              //setPageNo(1);
              setSearchText("");
              getFileShareListDetails("", 1, selectedNetwork);
              setHasMoreItems(true);
            }}
            placeholder={t("search")}
            type="search"
            autocomplete="off"
            autoCorrect="off"
            className={`searchbar ${isRoutedFromMediaList && "searchbar-classname"
              }`}
          ></IonSearchbar>
        </div>
        <div>
          {isN2nPermission && <div className="user-list-selection-btn-container"
            style={location?.state?.isNetworkSelectionDisabled ? { cursor: "not-allowed" } : { cursor: "pointer" }}
            onClick={() => location?.state?.isNetworkSelectionDisabled ? {} : setIsNetworkModalOpen(true)}
          >
            <p>{selectedNetwork ?? "Select Network"}</p>
            <div>
              <img src={DownArrowIcon} alt="" />
            </div>
          </div>}
          <IonModal
            isOpen={isNetworkModalOpen}
            backdropDismiss={false}
            className="add-schedule-model modal-popup-wrapper-nurse-site network-modal"
          // onDidDismiss={() => props.onOk(selectScheduleListData)}
          >
            <IonItem>
              <IonLabel className="schedule">Networks</IonLabel>
            </IonItem>
            <IonGrid className="scrollbar">
              <IonRow>
                <IonCol>
                  <IonList className="items">
                    {networkList?.length > 0 ?
                      <IonRadioGroup
                        value={choosenNetwork}
                        onIonChange={(e) => onNetworkChange(e.detail.value)}
                      >
                        {networkList?.map((item: any, index: number) => {
                          return (
                            <>
                              <IonItem lines="none" className="network-item">
                                <IonRadio value={item?.network} />
                                <IonLabel className="network-label-name">{item?.network}</IonLabel>
                              </IonItem>
                            </>
                          )
                        })}
                      </IonRadioGroup>
                      : (
                        <div className="no-results-label">No networks to display</div>
                      )}
                  </IonList>
                </IonCol>
              </IonRow>
            </IonGrid>
            <div className="buttons-container-div">
              <IonButton
                color="medium"
                className="cancel-button button secondary-btn btn-curved"
                onClick={handelNetworkModalCancel}
              >
                {t("cancel")}
              </IonButton>
              <IonButton
                // disabled={!isAnySchedulesSelected}
                className="submit-btn button primary-btn btn-curved"
                onClick={handelNetworkModalSubmit}
              >
                Ok
              </IonButton>
            </div>
          </IonModal>
        </div>
      </div>

      <div
        className={`doctor-list-container ${props.isModalPopUpScreen ? "doctor-list-container-height" : ""
          }
          ${props.isForwardMessage ? "adjust-list-height" : ""}
          `}
      >
        <InfiniteScroll
          dataLength={userListData.length}
          height={props.isModalPopUpScreen ? `45vh` : `60vh`}
          next={() => getFileShareListDetails(searchText, pageNo + 1)}
          hasMore={hasMoreItems}
          loader={<div className="select-user-loader">{/* <Loader /> */}</div>}
        >
          <DoctorList
            apiParams={apiParams}
            doctorListInputData={doctorListMessage}
            doctorListDataFromParent={userListData}
            permissions={rolePermissions}
            searchText={searchText}
            getSelectedCard={getSelectedDoctorList}
            getSelectedCardAndSchedule={() => { }}
            getIsAllSelectedStatus={() => { }}
            getAllCards={() => { }}
            getAllCardsAndSchedule={() => { }}
            isFullScreen={!props.isModalPopUpScreen}
            hideFeatureButtons={true}
            chatSelectedUser={selectedDoctorList}
            loader={showLoader}
          ></DoctorList>
        </InfiniteScroll>
      </div>

      {!_.isEmpty(selectedDoctorList) && (
        <div className="file-share-buttons-container user-selection-fwd">
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                props.isModalPopUpScreen ||
                  props.isRoutedFromMessages ||
                  props.isForwardMessage
                  ? props.onCancel()
                  : history.goBack();
              }}
            >
              {t("cancel")}
            </IonButton>
          </div>

          {!_.isEmpty(selectedDoctorList) &&
            !isRoutedFromMediaList &&
            !props.isRoutedFromMessages && (
              <div className="send-button-div">
                <div
                  onClick={() => {
                    if (location?.state?.isAddMember) {
                      addMember(selectedDoctorList);
                    } else {
                      history.push({
                        pathname: "/client/messages",
                        state: {
                          selectedDoctorData: selectedDoctorList,
                          mediaAction: CONSTANTS.MEDIA_ACTIONS.SEND,
                          n2nNetwork: selectedNetwork ?? '',
                          isFullscreen: true,
                        },
                      });
                    }
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <IonButton className="submit-btn button primary-btn btn-curved">
                    {location?.state?.isAddMember ? t("add") : t("next")}
                  </IonButton>
                </div>
              </div>
            )}

          {!_.isEmpty(selectedDoctorList) && props.isRoutedFromMessages && (
            <div className="send-button-div" onClick={onRedirectToMessageNext}>
              <IonButton className="submit-btn button primary-btn btn-curved">
                {t("next")}
              </IonButton>
            </div>
          )}

          {!_.isEmpty(selectedDoctorList) && isRoutedFromMediaList && (
            <div
              className="send-button-div"
              onClick={() => {
                if (props.forwardMessageDetails?.message_has_media) {
                  forwardMediaListItem();
                } else {
                  forwardMessage();
                }
              }}
            >
              <IonButton className="submit-btn button primary-btn btn-curved">
                {t("forward")}
              </IonButton>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectUserComponent;
